import React from 'react';
import { useTranslation } from 'react-i18next';

import { ViewSettings } from '../../../../../viewer/view-settings';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';
import { useViewSettings } from './view-settings/use-view-settings';

const OrthophotoTool = () => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);
  useViewSettings();

  return (
    <ToolIcon
      active={skyview.isClassicViewActive('orthophoto')}
      callback={() => ViewSettings.instance.showClassicView('orthophoto')}
      disabled={!skyview.isOrthoSceneAvailable()}
      icon={['fal', 'image']}
      tooltip={{
        title: t('orthophoto.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('orthophoto.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { OrthophotoTool };
